// Drill-down panel: the record behind a row, its lines and its totals.
// The page describes the content; the markup and the slide-in live here.
import React from "react";
import { X } from "feather-icons-react/build/IconComponents";
import { hueOf, initialsOf } from "./reportFormat";

// `actions` adds buttons after Close in the footer: [{label, onClick, primary}]
const ReportDrawer = ({ content, open, onClose, actions = [] }) => {
  if (!content) return null;
  const { title, subtitle, avatarKey, meta = [], lines, totals = [], net } = content;

  return (
    <>
      <div className={"axr-scrim" + (open ? " show" : "")} onClick={onClose} />
      <aside className={"axr-drawer" + (open ? " show" : "")} aria-hidden={!open}>
        <div className="axr-dhead">
          <span className="axr-av" style={{ "--h": hueOf(avatarKey || title) }}>
            {initialsOf(avatarKey || title)}
          </span>
          <div>
            <div className="axr-dt">{title}</div>
            <div className="axr-ds">{subtitle}</div>
          </div>
          <button type="button" className="axr-dclose" aria-label="Close" onClick={onClose}>
            <X />
          </button>
        </div>

        <div className="axr-dbody">
          {meta.length > 0 && (
            <div className="axr-dmeta">
              {meta.map((m) => (
                <div className="axr-dm" key={m.k}>
                  <div className="axr-dk">{m.k}</div>
                  <div className="axr-dv">{m.v == null || m.v === "" ? "—" : m.v}</div>
                </div>
              ))}
            </div>
          )}

          {lines && (
            <>
              <div className="axr-secthead">{lines.title || "Lines"}</div>
              <table className="axr-lines">
                <thead>
                  <tr>
                    {lines.columns.map((c, i) => (
                      <th key={i} className={c.align === "right" ? "r" : ""}>
                        {c.t}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {lines.rows.length === 0 && (
                    <tr>
                      <td colSpan={lines.columns.length} className="axr-nolines">
                        Nothing on this record
                      </td>
                    </tr>
                  )}
                  {lines.rows.map((cells, i) => (
                    <tr key={i}>
                      {cells.map((cell, j) => (
                        <td key={j} className={lines.columns[j]?.align === "right" ? "r" : ""}>
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {totals.length > 0 && (
            <div className="axr-dtot">
              {totals.map((t) => (
                <div className="axr-dtr" key={t.l}>
                  <span className="l">{t.l}</span>
                  <span className="v">{t.v}</span>
                </div>
              ))}
            </div>
          )}

          {net && (
            <div className="axr-dnet">
              <span className="l">{net.l}</span>
              <span className="v">{net.v}</span>
            </div>
          )}
        </div>

        <div className="axr-dfoot">
          <button type="button" className="axr-btn axr-btn-ghost" onClick={onClose}>
            Close
          </button>
          {actions.map((a) => (
            <button
              type="button"
              key={a.label}
              className={"axr-btn " + (a.primary ? "axr-btn-primary" : "axr-btn-ghost")}
              onClick={a.onClick}
            >
              {a.label}
            </button>
          ))}
        </div>
      </aside>
    </>
  );
};

export default ReportDrawer;
